<!-- Create Discussion Offcanvas -->
<div class="create-discussion-offcanvas" [class.open]="visible">
  <div class="offcanvas-backdrop" (click)="closeOffcanvas()"></div>
  <div class="offcanvas-content">
    <div class="offcanvas-header">
      <h2 class="offcanvas-title">New Discussion</h2>
      <button class="offcanvas-close" (click)="closeOffcanvas()" type="button">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
    
    <div class="offcanvas-body">
      <form [formGroup]="discussionForm" class="discussion-create--form">
        <!-- Choose Category -->
        <div class="form-group">
          <label for="category" class="form-label">
            Choose Category <span class="required-asterisk">*</span>
          </label>
          <select
            id="category"
            formControlName="category"
            class="form-select"
          >
            <option value="">Select a category</option>
            <option *ngFor="let option of categoryOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
          <div
            *ngIf="discussionForm.get('category')?.invalid && discussionForm.get('category')?.touched"
            class="error-message"
          >
            Category is required
          </div>
        </div>

        <!-- Discussion Title -->
        <div class="form-group">
          <label for="title" class="form-label">
            Discussion Title <span class="required-asterisk">*</span>
          </label>
          <input
            type="text"
            id="title"
            formControlName="title"
            class="form-input"
            placeholder="Enter discussion title"
            maxlength="200"
          />
          <div
            *ngIf="discussionForm.get('title')?.invalid && discussionForm.get('title')?.touched"
            class="error-message"
          >
            Title is required (max 200 characters)
          </div>
        </div>

        <!-- Choose Asset -->
        <div class="form-group">
          <label for="assetCategory" class="form-label">
            Choose Asset <span class="required-asterisk">*</span>
          </label>
          <select
            id="assetCategory"
            formControlName="assetCategory"
            class="form-select"
            (change)="onAssetCategoryChange()"
          >
            <option value="">Select asset type</option>
            <option *ngFor="let option of assetCategoryOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <!-- Choose Asset (Autocomplete) - shown when asset category is selected and not "Others" -->
        <div
          class="form-group"
          *ngIf="discussionForm.get('assetCategory')?.value && discussionForm.get('assetCategory')?.value !== 'Others'"
        >
          <label for="assetSearch" class="form-label">
            Choose {{ getAssetCategoryLabel(discussionForm.get('assetCategory')?.value) }} <span class="required-asterisk">*</span>
          </label>
          <div class="asset-search-wrapper">
            <input
              type="text"
              id="assetSearch"
              class="form-input asset-search-input"
              placeholder="Search {{ getAssetCategoryLabel(discussionForm.get('assetCategory')?.value) }}..."
              [(ngModel)]="assetSearchQuery"
              [ngModelOptions]="{standalone: true}"
              (input)="onAssetSearchInput($event)"
              (focus)="onAssetSearchFocus()"
              (blur)="onAssetSearchBlur()"
            />
            <button
              *ngIf="selectedAsset"
              type="button"
              class="asset-clear-btn"
              (click)="clearAsset()"
              title="Clear selection"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            
            <!-- Search Results Dropdown -->
            <div class="asset-search-results" *ngIf="showAssetSearchResults && assetSearchResults.length > 0">
              <div
                *ngFor="let result of assetSearchResults"
                class="asset-search-result-item"
                (click)="selectAsset(result)"
              >
                <span class="asset-search-result-name">{{ result.name }}</span>
                <span class="asset-search-result-type">{{ result.type }}</span>
              </div>
            </div>

            <div
              class="asset-search-results asset-search-results--empty"
              *ngIf="assetSearchQuery.trim().length >= 2 && showAssetSearchResults && assetSearchResults.length === 0"
            >
              <div class="asset-search-results--empty-text">{{ getAssetSearchEmptyMessage() }}</div>
            </div>
          </div>
          
          <!-- Selected Asset Display -->
          <div class="selected-value-container" *ngIf="selectedAsset">
            <span class="selected-value-text">{{ selectedAsset.name }}</span>
          </div>
        </div>

        <!-- Asset Name Input (shown when asset category is "Others") -->
        <div
          class="form-group"
          *ngIf="discussionForm.get('assetCategory')?.value === 'Others'"
        >
          <label for="assetName" class="form-label">
            Asset Name
          </label>
          <input
            type="text"
            id="assetName"
            formControlName="assetName"
            class="form-input"
            placeholder="Enter asset name"
          />
        </div>

        <!-- Custom Tags -->
        <div class="form-group">
          <label for="tags" class="form-label">
            Custom Tags <span class="required-asterisk">*</span>
          </label>
          <div class="tags-input-wrapper">
            <div class="tags-input-container">
              <input
                type="text"
                id="tags"
                class="tags-input"
                placeholder="Enter a tag"
                [(ngModel)]="tagInput"
                [ngModelOptions]="{standalone: true}"
                (keydown)="onTagInputKeydown($event)"
                (input)="onTagInputChange()"
                (paste)="onTagInputPaste($event)"
              />
              <button
                type="button"
                class="tags-add-button"
                (click)="addTag()"
                [disabled]="!canAddTag()"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            <div class="tags-container" *ngIf="getTags().length > 0">
              <span
                *ngFor="let tag of getTags()"
                class="tag-chip"
              >
                {{ tag }}
                <svg
                  class="tag-chip-close"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  (click)="removeTag(tag)"
                >
                  <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </div>
          </div>
          <div
            *ngIf="discussionForm.get('tags')?.invalid && discussionForm.get('tags')?.touched"
            class="error-message"
          >
            At least one tag is required
          </div>
        </div>

        <!-- Content Editor -->
        <div class="form-group">
          <label for="content" class="form-label">
            Content <span class="required-asterisk">*</span>
          </label>
          <div class="content-editor-wrapper">
            <p-editor
              formControlName="content"
              [style]="{ height: '300px' }"
              [modules]="editorModules"
              placeholder="Enter your discussion content..."
              (onInit)="onEditorInit($event)"
            ></p-editor>
            <div class="content-char-count">
              <span [class.text-danger]="contentLength > CONTENT_MAX_LENGTH">
                {{ contentLength }}/{{ CONTENT_MAX_LENGTH }} characters
              </span>
            </div>
          </div>
          <div
            *ngIf="discussionForm.get('content')?.invalid && discussionForm.get('content')?.touched"
            class="error-message"
          >
            Content is required
          </div>
        </div>

        <!-- Attachments -->
        <div class="form-group">
          <label for="attachments" class="form-label">
            Attachments
          </label>
          <div class="attachment-wrapper">
            <label for="fileInput" class="attachment-upload-label">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="17 8 12 3 7 8"></polyline>
                <line x1="12" y1="3" x2="12" y2="15"></line>
              </svg>
              <span>Upload Files</span>
              <span class="attachment-hint-inline">Allowed: {{ getAllowedFileTypesLabel() }}. Max size: 5MB per file.</span>
            </label>
            <input
              type="file"
              id="fileInput"
              class="attachment-input"
              accept=".pdf,.jpg,.jpeg,.png"
              multiple
              (change)="onFileSelected($event)"
            />
            
            <!-- Attachments List -->
            <div class="attachments-list" *ngIf="attachmentFiles.length > 0">
              <div *ngFor="let attachment of attachmentFiles; let i = index" class="attachment-item" [class.attachment-item--error]="attachment.error">
                <span class="attachment-name" [title]="getAttachmentDisplayName(attachment)">{{ getAttachmentDisplayName(attachment) }}</span>
                <span class="attachment-size" *ngIf="attachment.file">({{ formatFileSize(attachment.file.size) }})</span>
                <span class="attachment-status attachment-status--uploading" *ngIf="attachment.uploading">Uploading...</span>
                <span class="attachment-status attachment-status--error" *ngIf="attachment.error">{{ attachment.error }}</span>
                <button
                  type="button"
                  class="attachment-remove-btn"
                  (click)="removeAttachment(i)"
                  title="Remove"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <button type="button" class="btn-cancel" (click)="closeOffcanvas()">Cancel</button>
          <button type="button" class="btn-publish" (click)="publishDiscussion()">Publish</button>
        </div>
      </form>
    </div>
  </div>
</div>
